<div class="row gx-4 gy-5">
  <div class="col-12 col-xl-6">
    <div class="form-floating">
      @if (companyInfo()?.name) {
        <strong class="form-control border-0 text-truncate" id="addUserInputCompany">{{ companyInfo().name || EMPTY_VALUE }}</strong>
        <label class="form-floating-label" for="addUserInputCompany">
          {{ 'meterPoint.meterPointChangeRequest.currentContractPartnerStep.empty.company' | translate }}
        </label>
      }
    </div>
  </div>
  <div class="col-12 col-xl-6">
    <div class="form-floating">
      <strong class="form-control border-0" id="addUserInputCustomerNumber">{{ companyInfo()?.gpNr || EMPTY_VALUE }} </strong>
      <label class="form-floating-label" for="addUserInputCustomerNumber">
        {{ 'meterPoint.meterPointChangeRequest.currentContractPartnerStep.empty.customerNumber' | translate }}
      </label>
    </div>
  </div>
  <div class="col-12 col-xl-6">
    <div class="form-floating">
      <strong class="form-control border-0" id="addUserInputAddress">{{ addressFormatted() || EMPTY_VALUE }}</strong>
      <label class="form-floating-label" for="addUserInputAddress">
        {{ 'meterPoint.meterPointChangeRequest.currentContractPartnerStep.empty.address' | translate }}
      </label>
    </div>
  </div>
  <div class="col-12 col-xl-6">
    <div class="form-floating">
      <input
        type="text"
        class="form-control"
        id="addUserInputUid"
        [attr.data-test]="'newContractPartner-input-uidNumber'"
        [formControl]="uidControl"
        [class.is-invalid]="isUidInvalid()"
      />
      <label for="addUserInputUid">
        {{ 'meterPoint.meterPointChangeRequest.summary.newPartner.uid' | translate }}
      </label>
      @if (isUidInvalid() && getUidError()) {
        <div class="invalid-feedback">
          {{ getUidError() | translate }}
        </div>
      }
    </div>
  </div>
</div>
